<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="4" lg="4">
        <h1 class="text-center mb-2">{{this.$store.state.client_settings.APPNAME}}</h1>
        <h3 class="text-center mb-4">Iscriviti per creare il tuo account</h3>


        <MessageCard :show=show_success_box 
        title='Ben Fatto!' 
        sub_title='Registrazione avvenuta con Successo.' 
        action_icon='mdi-arrow-right'
        action_text='Vai al Login'
        action_link='/utente/login'
        footer_text='Riceverai a breve una mail di conferma. 
              Se non la trovi nella tua casella tra qualche minuto controlla la posta indesiderata o spam' >
        </MessageCard>
        
        <v-form ref="form" v-show="show_form" v-model="valid" :lazy-validation="lazy">
          <v-text-field
            outlined
            v-model="form.email"
            :append-icon="'mdi-email-outline'"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>
          <v-text-field
            outlined
            v-model="form.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            counter
            :rules="passwordRules"
            label="Password"
            @click:append="showPassword = !showPassword"
            required
          ></v-text-field>

          <v-checkbox
            v-model="toc_checkbox"
            :rules="[v => !!v || 'Devi accettare i termini e condizioni per proseguire']"
            label="Accetti Termini e Condizioni ?"
            required
          ></v-checkbox>

          <v-btn
            :disabled="!valid || registration_btn_loading"
            large
            color="success"
            block
            class="mr-4"
            :loading="registration_btn_loading"
            type='submit'
            @click="submit"
          >Registrati</v-btn>

          <v-alert v-if="registration_error_show" type="warning" class="mt-2 py-2 warning">
            <span v-text="registration_error_text"></span>
          </v-alert>
          <div class="mt-2">
            <router-link to="/utente/login">Hai già un account? Accedi</router-link>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mj_axios from "@/mj_axios.js";
import MessageCard from "@/components/MessageCard.vue";

export default {
  name: "Registration",
  //definiamo i componenti che desideriamo utilizzare in questo componente per evitare che venga creato un js troppo grande nella build
  components: {MessageCard},
  data: () => ({
    show_form: true,
    valid: true,
    toc_checkbox: false,
    show_success_box: false,
    registration_btn_loading: false,
    registration_error_show: false,
    registration_error_text: "",
    showPassword: false,
    form: {
      password: "",
      email: ""
    },
    passwordRules: [
      v => !!v || "Password Obbligatora is required",
      v => (v && v.length >= 8) || "Digita almeno 8 caratteri"
    ],

    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],

    lazy: false
  }),

  methods: {
    form_change: function() {
      
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.registration_btn_loading = true;

        const params = {
          email: this.form.email,
          password: this.form.password,
          password_confirmation: this.form.password,
          name: 'todo',
          roles_id: "utente"
        };

        mj_axios
          .post("/api/user/register", params)
          .then(() => {
            this.show_form = false;
            this.show_success_box = true;
          })
          .catch(e => {
            
            this.registration_error_show = true;
            this.registration_error_text =
              "Errore Durante la Registrazione: " + e.response.data.message;
          })
          .then(() => {
            // always executed
            this.registration_btn_loading = false;
          });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },
  watch: {
    form: {
      handler: function() {
        this.registration_error_show = false;
        return true;
      },
      deep: true
    }
  }
};
</script>
